import React, { Component } from 'react';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class NoTicketsModal extends Component {
    render() {
        return ( 
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isNoTicketsOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={this.props.toggleNoTickets} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">
                        {strings.title}
                    </h4>
                    {strings.description}
                    
                    <div className="d-flex justify-content-center">
                        <button 
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.props.toggleNoTickets}
                            >{strings.close}</button>  
                    </div>
                </ReactModal>
            </div>
        )
    }
}

export default NoTicketsModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/NoTicketsModal/NoTicketsModal.js